const dateFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  year: "2-digit",
  month: "2-digit",
  day: "2-digit",
});

export const dateToShortForm = (d: string): string => dateFormatter.format(new Date(d));

const dollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const dollarsTo2Places = (d: number): string => (d === 0 ? "0" : dollarFormatter.format(d));

export const percentTo3Places = (p: number): string => (p === 0 ? "0" : `${p.toFixed(3)}%`);
